import { useEffect, useRef } from 'react';

/**
 * Attach fade-in-on-scroll to any container.
 * All descendants with class="reveal" get an "is-visible" class when they enter the viewport.
 * Respects prefers-reduced-motion via CSS.
 */
export const useScrollReveal = (options = {}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current || document;
    const targets = root.querySelectorAll('.reveal');
    if (!targets.length) return;

    // If IntersectionObserver is not supported, reveal immediately
    if (typeof IntersectionObserver === 'undefined') {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px', ...options }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [options]);

  return containerRef;
};
